import scriptJs from "scriptjs";
import {
    detectMob,
    getBrowserName,
    getMobileOperatingSystem,
    getOperatingSystem,
    getUrlParameter,
    validateBadWords,
    addErrorValidate,
    checkEmail,
    checkPhone,
    getCookie,
    getTrackingParams,
    deleteCookie,
    setCookie
} from "./utils";
import IMask from "imask";
import Jquery from "mark.js/src/jquery";
import Cookies from "js-cookie";

// --- Client Logging Utilities for Salesforce/Hubspot tracking ---
// Mask email for privacy
function maskEmail(email) {
    if (!email || typeof email !== 'string') return '';
    const [user, domain] = email.split('@');
    if (!domain) return email.replace(/.(?=.{2})/g, '*');
    const maskedUser = user.length <= 2 ? user[0] + '*' : user[0] + '*'.repeat(Math.max(1, user.length - 2)) + user[user.length - 1];
    return maskedUser + '@' + domain;
}
// Generate correlation id
function generateCorrId() {
    return 'ed-' + Math.random().toString(36).slice(2, 10) + '-' + Date.now().toString(36);
}
// Sender: uses navigator.sendBeacon if available, else axios
window.__edClientLogSend = function(messages, level = 'info', extra = {}) {
    try {
        const payload = {
            messages: Array.isArray(messages) ? messages : [messages],
            level,
            correlationId: extra.correlationId || window.__edCorrId || null,
            formTitle: extra.formTitle || null,
            email: extra.emailMasked || null,
            page: window.location.href
        };
        const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
        if (navigator.sendBeacon) {
            return navigator.sendBeacon('/client-log', blob);
        }
        if (window.axios && typeof window.axios.post === 'function') {
            return window.axios.post('/client-log', payload, { timeout: 2000 }).catch(() => {});
        }
    } catch (e) {
        // swallow
    }
};

// Axios interceptor to capture API failures of interest
if (window.axios && typeof window.axios.interceptors !== 'undefined') {
    window.axios.interceptors.response.use(
        function (response) { return response; },
        function (error) {
            try {
                const url = (error && error.config && (error.config.url || '')) || '';
                const interesting = ['/check-salesforce-contact', '/send-to-salesforce', '/get-registration-flow', '/hubspot-form'];
                if (interesting.some(p => url.indexOf(p) !== -1)) {
                    const status = error.response && error.response.status;
                    const data = error.response && error.response.data;
                    window.__edClientLogSend([
                        {
                            event: 'api_failure',
                            url,
                            status: status || null,
                            error: (error.message || 'unknown'),
                            response: (typeof data === 'string' ? data : (data || {})),
                            ts: new Date().toISOString()
                        }
                    ], 'error', { correlationId: window.__edCorrId || null, formTitle: (typeof document!=='undefined'? (document.querySelector("input[name='hubspot_form_title']")?.value || null): null) });
                }
            } catch (e) {}
            return Promise.reject(error);
        }
    );
}

window.heap = window.heap || [], heap.load = function (e, t) {
    window.heap.appid = e, window.heap.config = t = t || {};
    var r = t.forceSSL || "https:" === document.location.protocol, a = document.createElement("script");
    a.type = "text/javascript", a.async = !0, a.src = (r ? "https:" : "http:") + "//cdn.heapanalytics.com/js/heap-" + e + ".js";
    var n = document.getElementsByTagName("script")[0];
    n.parentNode.insertBefore(a, n);
    for (var o = function (e) {
        return function () {
            heap.push([e].concat(Array.prototype.slice.call(arguments, 0)))
        }
    }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"], c = 0; c < p.length; c++) heap[p[c]] = o(p[c])
};
// Use HEAP_TRACKING_SERVER from environment if available, otherwise default to heapdata.exactdata.com
const HEAP_TRACKING_SERVER = typeof HEAP_TRACKING_SERVER !== 'undefined' ? HEAP_TRACKING_SERVER : 'heapdata.exactdata.com';
heap.load(HEAP_APP_ID, {trackingServer: "https://" + HEAP_TRACKING_SERVER});

window.onLoadedHubsposts =($form,formName)=>
{
    var $input = $(".hs-input");
    var  phoneField = $form[0].querySelector("input[name='phone']");
    /*phoneField.onfocus=((value) => {
        IMask(phoneField, {
            mask: "(000)000-0000",
            lazy: false
        });

});
    phoneField.onfocusout=((value) => {
        if(phoneField.value=='' || phoneField.value=='(___)___-____')
        {
            //$('.phone-plus').css('display','none');
            /!*$("#phoneField.id")
                .parent()
                .parent()
                .removeClass("active");*!/
            IMask(phoneField, {
                mask: Number,
                lazy: false
            });
            phoneField.value='';

        }
    });
// move label on input focus
    $input
        .on("focus", function() {
            $('.phone-plus').css('display','flex');
            $(this)
                .parent()
                .parent()
                .addClass("active");
        })
        .blur();

// move label if input is empty or not
    $input
        .focusout(function() {
            if (!$(this).val() || $(this).val()=='(___)___-____') {
                $('.phone-plus').css('display','none');
                $(this)
                    .parent()
                    .parent()
                    .removeClass("active");
            } else {
                $(this)
                    .parent()
                    .parent()
                    .addClass("active");
            }
        })
        .focusout(); // focusout event for prefilled forms
*/
    let thank_you_url = window.location.href;
    if (thank_you_url.indexOf('?aliId=54938600') === -1) {
        let params = window.location.search.replace('?', '').split('&').reduce(function (p, e) {
                let a = e.split('=');
                if (a[0] !== '' && a[1] !== 'undefined') {
                    p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
                }
                return p;
            },
            {}
        );

        if (typeof params !== "undefined" && params != '' && params != null && Object.keys(params).length !== 0) {
            let date = new Date();
            date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
            const expires = "expires=" + date.toUTCString();
            document.cookie = "_tracking_params" + "=" + encodeURIComponent(JSON.stringify(params)) + "; " + expires + "; path=/";
        }

        let all_params_to_track = [
            'keyword',
            'matchtype',
            'network',
            'adposition',
            'adgroupid',
            'gclid',
            'msclkid',
            'utm_source',
            'utm_medium',
            'utm_campaign',
            'utm_term',
            'utm_content',
            'campaignid',
            'extensionid',
            'sfcid',
            'media_code',
            'facebook_cookie_fbc',
            'facebook_cookie_fbp',
            'fbclid',
            'leadsource'
        ];

        all_params_to_track.forEach(function (param) {
            if (typeof params[param] !== "undefined" && params[param] && params[param] != '' && params[param] != null) {
                deleteCookie(param);
                setCookie(param, params[param], 30);
            }
        });
    }

    let device = "";
    device += detectMob() ? "Mobile" : "Desktop";
    device += ", " + getBrowserName();
    getBrowserName()
    if (detectMob()) {
        device += ", " + getMobileOperatingSystem();
    } else {
        device += ", " + getOperatingSystem();
    }

    document.getElementsByClassName('loader')[0].style.display = 'none';
    jQuery('.loader').css('display','none');
    const firstNameFromUrl = getUrlParameter("firstName");
    const lastNameFromUrl = getUrlParameter("lastName");
    const emailFromUrl = getUrlParameter("email");
    const phoneFromUrl = getUrlParameter("phone");
    var  phoneField = $form[0].querySelector("input[name='phone']");
    let submitBtn = $form[0].querySelector(".hs-button ");
    let firstNameField = $form[0].querySelector("input[name='firstname']");
    let lastNameField = $form[0].querySelector("input[name='lastname']");
    let company = $form[0].querySelector("input[name='company']") ? $form[0].querySelector("input[name='company']") : null;
    let emailField = $form[0].querySelector("input[name='email']");

    // Helper function to get company value for hbEntry
    // If company field doesn't exist or is empty, use firstname + lastname
    const getCompanyForHbEntry = () => {
        if (company && company.value && company.value.trim() !== '') {
            return company.value;
        }
        // For forms without company field (like 15% popup), use firstname + lastname
        const firstName = firstNameField ? firstNameField.value.trim() : '';
        const lastName = lastNameField ? lastNameField.value.trim() : '';
        return (firstName + ' ' + lastName).trim() || '';
    };

    let mode =  $form[0].querySelector("input[name='send_email']");
    let unsubscribed =  $form[0].querySelector("input[name='unsubscribed_from_all_email__form_']");
    let hubspot_form_title = $form[0].querySelector("input[name='hubspot_form_title']");
    let form_src =  $form[0].querySelector("input[name='form_src']");
    let form_site =  $form[0].querySelector("input[name='form_site']");
    let devicevalue =  $form[0].querySelector("input[name='device']");
    let form_lead_id =  $form[0].querySelector("input[name='form_lead_id']");
    let ip =  $form[0].querySelector("input[name='ip']");
    let placeholdertext = $form[0].querySelector("textarea[name='who_is_your_ideal_audience_']") ? $form[0].querySelector("textarea[name='who_is_your_ideal_audience_']") : '';

    //keyword
    let keyword =  $form[0].querySelector("input[name='keyword']");
    keyword.value = getUrlParameter('keyword') ? getUrlParameter('keyword') : getCookie('keyword') ? getCookie('keyword') : 'Not Present';
    // matchtype
    let matchtype = $form[0].querySelector("input[name='matchtype']");
    matchtype.value = getUrlParameter('matchtype') ? getUrlParameter('matchtype') : getCookie('matchtype') ? getCookie('matchtype') : 'Not Present';
    // network
    let network = $form[0].querySelector("input[name='network']");
    network.value = getUrlParameter('network') ? getUrlParameter('network') : getCookie('network') ? getCookie('network') : 'Not Present';
    // adposition
    let ad_position = $form[0].querySelector("input[name='ad_position']");
    ad_position.value = getUrlParameter('adposition') ? getUrlParameter('adposition') : getCookie('adposition') ? getCookie('adposition') : 'Not Present';
    // adgroupid
    let adgroup_id = $form[0].querySelector("input[name='adgroup_id']");
    adgroup_id.value = getUrlParameter('adgroupid') ? getUrlParameter('adgroupid') : getCookie('adgroupid') ? getCookie('adgroupid') : 'Not Present';
    // heap_session_id
    let heap_session_id = $form[0].querySelector("input[name='heap_session_id']");
    const heapSessionValue = processHeapData();
    heap_session_id.value = heapSessionValue;
    // extensionid
    let extension_id = $form[0].querySelector("input[name='extension_id']");
    extension_id.value = getUrlParameter('extensionid') ? getUrlParameter('extensionid') : getCookie('extensionid') ? getCookie('extensionid') : 'Not Present';
    // sfcid/campaignid
    let sfcid = $form[0].querySelector("input[name='sfcid']");
    if (getUrlParameter('sfcid'))
    {
        sfcid.value = getUrlParameter('sfcid');
    }
    else if (getCookie('sfcid') && !getUrlParameter('sfcid'))
    {
        sfcid.value = getCookie('sfcid');
    }
    // else if (getTrackingParams(getCookie('_tracking_params')) && !getUrlParameter('sfcid') && !getCookie('sfcid'))
    // {
    //     sfcid.value = null;
    // }
    else
    {
        sfcid.value = '701Oy000009bkpt';
    }
    // gclid
    let gclid = $form[0].querySelector("input[name='gclid']");
    gclid.value = getUrlParameter('gclid') ? getUrlParameter('gclid') : getCookie('gclid') ? getCookie('gclid') : 'Not Present';
    // msclkid
    let ms_click_id = $form[0].querySelector("input[name='ms_click_id']");
    ms_click_id.value = getUrlParameter('msclkid') ? getUrlParameter('msclkid') : getCookie('msclkid') ? getCookie('msclkid') : 'Not Present';
    // utm_campaign
    let utm_campaign = $form[0].querySelector("input[name='utm_campaign']");
    utm_campaign.value = getUrlParameter('utm_campaign') ? getUrlParameter('utm_campaign') : getCookie('utm_campaign') ? getCookie('utm_campaign') : 'Not Present';
    // utm_term
    let utm_term = $form[0].querySelector("input[name='utm_term']");
    utm_term.value = getUrlParameter('utm_term') ? getUrlParameter('utm_term') : getCookie('utm_term') ? getCookie('utm_term') : 'Not Present';
    // utm_source
    let utm_source = $form[0].querySelector("input[name='utm_source']");
    utm_source.value = getUrlParameter('utm_source') ? getUrlParameter('utm_source') : getCookie('utm_source') ? getCookie('utm_source') : 'Not Present';
    // utm_medium
    let utm_medium = $form[0].querySelector("input[name='utm_medium']");
    utm_medium.value = getUrlParameter('utm_medium') ? getUrlParameter('utm_medium') : getCookie('utm_medium') ? getCookie('utm_medium') : 'Not Present';
    // utm_content
    let utm_content = $form[0].querySelector("input[name='utm_content']");
    utm_content.value = getUrlParameter('utm_content') ? getUrlParameter('utm_content') : getCookie('utm_content') ? getCookie('utm_content') : 'Not Present';
    // page_url__long_text_
    let page_url = $form[0].querySelector("input[name='page_url__long_text_']");
    page_url.value = window.location.href;
    // google_analytics_campaign
    let google_analytics_campaign = $form[0].querySelector("input[name='google_analytics_campaign']");
    google_analytics_campaign.value = getUrlParameter('campaignid') ? getUrlParameter('campaignid') : getCookie('campaignid') ? getCookie('campaignid') : 'Not Present';
    // facebook_cookie_fbc
    let facebook_cookie_fbc = $form[0].querySelector("input[name='facebook_cookie_fbc']");
    facebook_cookie_fbc.value = getUrlParameter('facebook_cookie_fbc') ? getUrlParameter('facebook_cookie_fbc') : getCookie('facebook_cookie_fbc') ? getCookie('facebook_cookie_fbc') : 'Not Present';
    // facebook_cookie_fbp
    let facebook_cookie_fbp = $form[0].querySelector("input[name='facebook_cookie_fbp']");
    facebook_cookie_fbp.value = getUrlParameter('facebook_cookie_fbp') ? getUrlParameter('facebook_cookie_fbp') : getCookie('facebook_cookie_fbp') ? getCookie('facebook_cookie_fbp') : 'Not Present';
    // fbclid
    let fbclid = $form[0].querySelector("input[name='fbclid']");
    fbclid.value = getUrlParameter('fbclid') ? getUrlParameter('fbclid') : getCookie('fbclid') ? getCookie('fbclid') : 'Not Present';
    // browser_user_agent
    let browser_user_agent = $form[0].querySelector("input[name='browser_user_agent']");
    let browser_name = getBrowserName();
    browser_user_agent.value = browser_name;
    // media_code
    let media_code = $form[0].querySelector("input[name='media_code']");
    if (getUrlParameter('media_code'))
    {
        media_code.value = getUrlParameter('media_code');
    }
    else if (getCookie('media_code') && !getUrlParameter('media_code'))
    {
        media_code.value = getCookie('media_code');
    }
    // else if (getTrackingParams(getCookie('_tracking_params')) && !getUrlParameter('media_code') && !getCookie('media_code'))
    // {
    //     media_code.value = null;
    // }
    else
    {
        media_code.value = 'EXDCMSW00100';
    }
    // leadsource
    let leadsource = $form[0].querySelector("input[name='leadsource']");
    if (getUrlParameter('leadsource'))
    {
        leadsource.value = getUrlParameter('leadsource');
    }
    else if (getCookie('leadsource') && !getUrlParameter('leadsource'))
    {
        leadsource.value = getCookie('leadsource');
    }
    // else if (getTrackingParams(getCookie('_tracking_params')) && !getUrlParameter('leadsource') && !getCookie('leadsource'))
    // {
    //     leadsource.value = null;
    // }
    else
    {
        leadsource.value = 'Website';
    }

    // form_src
    form_src.value = 'Website';
    // form_site
    form_site.value = 'ExactData';
    // form_leadid
    form_lead_id.value = '';
    // ip
    ip.value = STATIC_IP;
    // device
    devicevalue.value = device;

    if (firstNameFromUrl) {
        firstNameField.value = firstNameFromUrl;
    }
    if (lastNameFromUrl) {
        lastNameField.value = lastNameFromUrl;
    }
    if (emailFromUrl) {
        emailField.value = emailFromUrl;
    }
    if (phoneFromUrl) {
        phoneField.value = phoneFromUrl;
    }

    let arrayValidate = [firstNameField, lastNameField, emailField];
    if (phoneField) {
        arrayValidate.push(phoneField);
        let el = document.createElement("span");
        el.classList.add("phone-plus");
        el.id=formName+"phone-plus";
        el.innerHTML = "+1";
        phoneField.parentNode.insertBefore(el, phoneField.nextSibling);
        phoneField.classList.add("phone-control");
    }
    $form[0].querySelectorAll(".hs-form-field").forEach(event => {
        event.addEventListener("input", (_event) => {
            _event.target.classList.remove("invalid");
            if (_event.target.closest(".hs-form-field").querySelector(".mktoCustomError")) {
                _event.target.closest(".hs-form-field").querySelector(".mktoCustomError").remove();
            }
        });
    });
    submitBtn.addEventListener("click", async (e) => {
        // Log form submission start
        const formTitle = hubspot_form_title?.value || 'Unknown';
        const formNameValue = formName || 'Unknown';
        // Generate correlation ID for tracking this submission across client/server logs
        window.__edCorrId = (typeof generateCorrId === 'function') ? generateCorrId() : ('ed-' + Math.random().toString(36).slice(2,10) + '-' + Date.now().toString(36));
        
        // Send client log entry to backend for persistence
        if (typeof window.__edClientLogSend === 'function') {
            window.__edClientLogSend([
                { event: 'submission_start', timestamp: new Date().toISOString(), formName: formNameValue }
            ], 'info', { correlationId: window.__edCorrId, formTitle: formTitle, emailMasked: (typeof maskEmail==='function'? maskEmail(emailField?.value): (emailField?.value||'')) });
        }

        if (hubspot_form_title.value !== '' && (hubspot_form_title.value === '15% Popup DW Homepage' || hubspot_form_title.value === '15% Popup DW Other page' || hubspot_form_title.value === 'RML Get Count Popup'))
        {
            $('.popup-loader').css('display','flex');
            $('.pre-loader').css('display','none');
        }

        if (hubspot_form_title.value !== '' && (hubspot_form_title.value === 'RML Sidebar form' || hubspot_form_title.value === 'Contact us'))
        {
            $('.pre-loader').css('display','flex');
            $('.popup-loader').css('display','none');
        }

        e.stopPropagation();
        e.preventDefault();

        $form[0].querySelectorAll(".hs-form-field").forEach(wrap => {
            wrap.classList.remove("hs-error-msg");
        });

        $form[0].querySelectorAll(".mktoCustomError").forEach(wrap => {
            wrap.remove();
        });

        let validForm = true;

        arrayValidate.forEach(field => {
            if (!field.value) {
                addErrorValidate(field, "This field is required.");
                validForm = false;
            }
        });

        if (validForm) {
            if (firstNameField && firstNameField.value) {
                validForm = validateBadWords(firstNameField, "Please enter a valid first name.");
            }

            if (lastNameField && lastNameField.value) {
                validForm = validateBadWords(lastNameField, "Please enter a valid last name.");
            }
        }

        if (validForm) {
            submitBtn.setAttribute("disabled", "");

            let promises = [];

            let payloadEmail = {
                email: emailField.value
            };

            promises.push(checkEmail(payloadEmail, emailField));

            if (phoneField) {
                let payloadPhone = {
                    phone: phoneField.value
                };

                promises.push(checkPhone(payloadPhone, phoneField));
            }

            let results = await Promise.allSettled(promises);

            // bp_phone_status
            let bp_phone_status = $form[0].querySelector("input[name='bp_phone_status']");
            bp_phone_status.value = phone_status;

            // bp_line_type
            let bp_line_type = $form[0].querySelector("input[name='bp_line_type']");
            bp_line_type.value = line_type;

            var typeForm = 'promo';

            let successfulPromises = results.filter(p => p.status === "rejected");

            if (!successfulPromises.length) {

                // Step 1: Call GetRegistrationFlow API first
                let registrationFlowResponse = null;
                let salesgenieProductList = null;

                try {

                    const regFlowResponse = await window.axios.post('/get-registration-flow', {
                        email: emailField.value,
                        phone: phoneField ? phoneField.value : '',
                        force_type: '',
                        calling_application: 'ExactData'
                    });

                    registrationFlowResponse = regFlowResponse.data;

                    // Check UserFlowType from response (case-insensitive)
                    const userFlowTypeRaw = regFlowResponse.data?.UserFlowType
                        || regFlowResponse.data?.userFlowType
                        || regFlowResponse.data?.UserFlow
                        || regFlowResponse.data?.user_flow_type
                        || null;
                    const userFlowType = userFlowTypeRaw ? String(userFlowTypeRaw).toUpperCase() : null;

                    // Only call GetProductListOfUser if UserFlowType is NXG
                    if (userFlowType === 'NXG') {

                        // Step 2: If UserFlowType is NXG, call GetProductListOfUser
                        try {
                            const sgResponse = await window.axios.post('/get-product-list', {
                                email: emailField.value
                            });

                            // Check if product list has data (user exists)
                            const hasProductListData = sgResponse && sgResponse.data &&
                                (sgResponse.data.Salesgenie === "Salesgenie" || sgResponse.data.Exactdata === "Exactdata");

                            if (hasProductListData) {

                                // YES scenario: Redirect to welcome back page with email ID as query parameter only
                                // Welcome back URL for YES scenario (user has product list)
                                const baseUrl = (typeof window.SALESGENIE_WELCOME_BACK_URL !== 'undefined' && window.SALESGENIE_WELCOME_BACK_URL) 
                                    ? window.SALESGENIE_WELCOME_BACK_URL 
                                    : 'https://exactdata.com/info/thank-you-welcome-back-sg/';

                                // Set hbEntry cookie (same pattern as reference code)
                                // Extract 10-digit phone number (remove formatting)
                                const phoneValue = phoneField && phoneField.value ? phoneField.value.replace(/\D/g, '').substring(0, 10) : '';
                                const hbEntry = {
                                    email: emailField.value,
                                    phone: phoneValue,
                                    firstname: firstNameField.value,
                                    lastname: lastNameField.value,
                                    company: (company && company.value && company.value.trim() !== '') ? company.value : (firstNameField.value + ' ' + lastNameField.value).trim()
                                };

                                // Set cookie with 30 days expiry, domain exactdata.com, secure only on https
                                Cookies.set('hbEntry', JSON.stringify(hbEntry), {
                                    domain: "exactdata.com",
                                    path: "/",
                                    expires: 30,
                                    secure: (window.location.protocol === 'https:')
                                });

                                // Build query parameters - ONLY email ID for welcome back page
                                const queryParams = new URLSearchParams();
                                queryParams.append('email', emailField.value);

                                // Still set tracking cookies (but don't pass them in URL for welcome back page)
                                const trackingParams = [
                                    'keyword', 'matchtype', 'network', 'adposition', 'adgroupid',
                                    'gclid', 'msclkid', 'utm_source', 'utm_medium', 'utm_campaign',
                                    'utm_term', 'utm_content', 'campaignid', 'extensionid', 'sfcid',
                                    'media_code', 'facebook_cookie_fbc', 'facebook_cookie_fbp', 'fbclid', 'leadsource'
                                ];

                                const trackingParamsObj = {};
                                trackingParams.forEach(param => {
                                    const value = getCookie(param) ||
                                                 (param === 'sfcid' ? sfcid.value :
                                                  param === 'gclid' ? gclid.value :
                                                  param === 'msclkid' ? ms_click_id.value :
                                                  param === 'utm_campaign' ? utm_campaign.value :
                                                  param === 'utm_term' ? utm_term.value :
                                                  param === 'utm_source' ? utm_source.value :
                                                  param === 'utm_medium' ? utm_medium.value :
                                                  param === 'utm_content' ? utm_content.value :
                                                  param === 'adgroupid' ? adgroup_id.value :
                                                  param === 'extensionid' ? extension_id.value :
                                                  param === 'facebook_cookie_fbc' ? facebook_cookie_fbc.value :
                                                  param === 'facebook_cookie_fbp' ? facebook_cookie_fbp.value :
                                                  param === 'fbclid' ? fbclid.value :
                                                  param === 'leadsource' ? leadsource.value :
                                                  param === 'media_code' ? media_code.value :
                                                  param === 'campaignid' ? google_analytics_campaign.value : null);

                                    if (value && value !== 'Not Present' && value !== '') {
                                        // Set cookie for tracking (30 days) - but don't add to URL
                                        setCookie(param, value, 30);
                                        trackingParamsObj[param] = value;
                                    }
                                });

                                // Store tracking params in cookie (similar to CreateNewUser.php)
                                if (Object.keys(trackingParamsObj).length > 0) {
                                    const date = new Date();
                                    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
                                    const expires = "expires=" + date.toUTCString();
                                    // Set cookie with proper attributes
                                    let cookieString = "_tracking_params" + "=" + encodeURIComponent(JSON.stringify(trackingParamsObj)) + "; " + expires + "; path=/; SameSite=Lax";
                                    document.cookie = cookieString;
                                }

                                // Build final URL with ONLY email as query parameter
                                const welcomeBackUrl = baseUrl + (queryParams.toString() ? '?' + queryParams.toString() : '');

                                // Small delay to ensure cookie is persisted
                                setTimeout(() => {
                                    window.location.href = welcomeBackUrl;
                                }, 100);
                                return; // Stop further execution
                            } else {

                                // Step 3: Call Salesforce APIs - First get token, then check if contact exists
                                let contactExists = false;

                                try {

                                    const contactCheckResponse = await window.axios.post('/check-salesforce-contact', {
                                        email: emailField.value
                                    });

                                    if (contactCheckResponse.data?.success) {
                                        contactExists = contactCheckResponse.data.isContactExist || false;
                                        const sfContactId = contactCheckResponse.data.SFContactId || null;

                                        // Step 4: Call Salesforce API to update (if exists) or create (if new) with salesgenie_product_experiment
                                        try {

                                            // Refresh heap_session_id at submission time to get the latest value from Heap
                                            const latestHeapSessionId = processHeapData();
                                            if (heap_session_id) {
                                                heap_session_id.value = latestHeapSessionId;
                                            }

                                            // Prepare Salesforce payload with all form data + salesgenie_product_experiment
                                            const safeVal = (el, fb = '') => (el && typeof el.value !== 'undefined' && el.value !== null) ? el.value : fb;
                                            const sfPayload = {
                                                firstname: safeVal(firstNameField),
                                                lastname: safeVal(lastNameField),
                                                // If company is null/empty, fall back to "firstname lastname"
                                                companyname: (company && company.value && company.value.trim() !== ''
                                                    ? company.value
                                                    : (String(firstNameField?.value || '').trim() + ' ' + String(lastNameField?.value || '').trim()).trim()),
                                                phone: safeVal(phoneField),
                                                email: safeVal(emailField),
                                                ip: safeVal(ip, STATIC_IP || ''),
                                                hsformtitle: safeVal(hubspot_form_title),
                                                page_url_long_text: safeVal(page_url, window.location.href || ''),
                                                leadsource: safeVal(leadsource, 'Website'),
                                                mediacode: safeVal(media_code, 'EXDCMSW00100'),
                                                campaignid: safeVal(sfcid, '701Oy000009bkpt'),
                                                comments: (typeof placeholdertext === 'string' ? placeholdertext : safeVal(placeholdertext, '')),
                                                device: safeVal(devicevalue),
                                                gclid: safeVal(gclid),
                                                msclkid: safeVal(ms_click_id),
                                                utm_campaign: safeVal(utm_campaign),
                                                utm_medium: safeVal(utm_medium),
                                                utm_content: safeVal(utm_content),
                                                utm_source: safeVal(utm_source),
                                                utm_term: safeVal(utm_term),
                                                google_campaign: safeVal(google_analytics_campaign),
                                                adgroupid: safeVal(adgroup_id),
                                                keyword: safeVal(keyword),
                                                matchtype: safeVal(matchtype),
                                                network: safeVal(network),
                                                extensionid: safeVal(extension_id),
                                                fbclid: safeVal(fbclid),
                                                facebook_cookie_fbp: safeVal(facebook_cookie_fbp),
                                                facebook_cookie_fbc: safeVal(facebook_cookie_fbc),
                                                browser_user_agent: safeVal(browser_user_agent, getBrowserName()),
                                                bp_phone_status: (typeof bp_phone_status !== 'undefined' && bp_phone_status ? safeVal(bp_phone_status) : ''),
                                                bp_line_type: (typeof bp_line_type !== 'undefined' && bp_line_type ? safeVal(bp_line_type) : ''),
                                                heap_session_id: safeVal(heap_session_id), // Include heap session ID from hidden form field
                                                single_tracking_parameter: true, // Ensure only 1 tracking parameter record is created
                                                salesgenie_product_experiment: 'Unify – ED > NXG',
                                                // Pass contact existence info from check API
                                                contact_exists: contactExists,
                                                sf_contact_id: sfContactId
                                            };
                                            
                                            const sfResponse = await window.axios.post('/send-to-salesforce', sfPayload);


                                            // Both scenarios: Redirect to thank you salesgenie page
                                            const baseUrl = sfResponse.data?.redirect_url 
                                                || (typeof window.SALESGENIE_THANK_YOU_URL !== 'undefined' && window.SALESGENIE_THANK_YOU_URL)
                                                || 'https://exactdata.com/info/thank-you-salesgenie/';

                                            // Set hbEntry cookie (same pattern as reference code)
                                            // Extract 10-digit phone number (remove formatting)
                                            const phoneValue = phoneField && phoneField.value ? phoneField.value.replace(/\D/g, '').substring(0, 10) : '';
                                            const hbEntry = {
                                                email: emailField.value,
                                                phone: phoneValue,
                                                firstname: firstNameField.value,
                                                lastname: lastNameField.value,
                                                company: getCompanyForHbEntry()
                                            };

                                            // Set cookie with 30 days expiry, domain exactdata.com, secure only on https
                                            Cookies.set('hbEntry', JSON.stringify(hbEntry), {
                                                domain: "exactdata.com",
                                                path: "/",
                                                expires: 30,
                                                secure: (window.location.protocol === 'https:')
                                            });

                                            // Store tracking parameters in cookies (not in URL)
                                            const trackingParams = [
                                                'keyword', 'matchtype', 'network', 'adposition', 'adgroupid',
                                                'gclid', 'msclkid', 'utm_source', 'utm_medium', 'utm_campaign',
                                                'utm_term', 'utm_content', 'campaignid', 'extensionid', 'sfcid',
                                                'media_code', 'facebook_cookie_fbc', 'facebook_cookie_fbp', 'fbclid', 'leadsource'
                                            ];

                                            // Store tracking params in cookie
                                            const trackingParamsObj = {};
                                            trackingParams.forEach(param => {
                                                const value = getCookie(param) ||
                                                             (param === 'sfcid' ? sfcid.value :
                                                              param === 'gclid' ? gclid.value :
                                                              param === 'msclkid' ? ms_click_id.value :
                                                              param === 'utm_campaign' ? utm_campaign.value :
                                                              param === 'utm_term' ? utm_term.value :
                                                              param === 'utm_source' ? utm_source.value :
                                                              param === 'utm_medium' ? utm_medium.value :
                                                              param === 'utm_content' ? utm_content.value :
                                                              param === 'adgroupid' ? adgroup_id.value :
                                                              param === 'extensionid' ? extension_id.value :
                                                              param === 'facebook_cookie_fbc' ? facebook_cookie_fbc.value :
                                                              param === 'facebook_cookie_fbp' ? facebook_cookie_fbp.value :
                                                              param === 'fbclid' ? fbclid.value :
                                                              param === 'leadsource' ? leadsource.value :
                                                              param === 'media_code' ? media_code.value :
                                                              param === 'campaignid' ? google_analytics_campaign.value : null);

                                                if (value && value !== 'Not Present' && value !== '') {
                                                    trackingParamsObj[param] = value;
                                                    setCookie(param, value, 30);
                                                }
                                            });

                                            if (Object.keys(trackingParamsObj).length > 0) {
                                                const date = new Date();
                                                date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
                                                const expires = "expires=" + date.toUTCString();
                                                let cookieString = "_tracking_params" + "=" + encodeURIComponent(JSON.stringify(trackingParamsObj)) + "; " + expires + "; path=/; SameSite=Lax";
                                                document.cookie = cookieString;
                                            }

                                            // Use base URL without query parameters (data is in cookies)
                                            const thankYouUrl = baseUrl;

                                            // Small delay to ensure cookie is persisted
                                            setTimeout(() => {
                                                window.location.href = thankYouUrl;
                                            }, 100);
                                            return; // Stop further execution

                                        } catch (sfError) {
                                            console.error('=== Salesforce Send API Error ===');
                                            console.error('→ Form:', formTitle);
                                            console.error('→ Email:', emailField.value);
                                            console.error('→ Error:', sfError.message);
                                            console.error('→ Error Response:', sfError.response?.data);
                                            console.error('→ Error Status:', sfError.response?.status);
                                            console.error('→ Full Error:', sfError);
                                            // Still redirect even if Salesforce call fails
                                            const baseUrl = (typeof window.SALESGENIE_THANK_YOU_URL !== 'undefined' && window.SALESGENIE_THANK_YOU_URL) 
                                                ? window.SALESGENIE_THANK_YOU_URL 
                                                : 'https://exactdata.com/info/thank-you-salesgenie/';

                                            // Set hbEntry cookie (error fallback)
                                            const phoneValue = phoneField && phoneField.value ? phoneField.value.replace(/\D/g, '').substring(0, 10) : '';
                                            const hbEntry = {
                                                email: emailField.value,
                                                phone: phoneValue,
                                                firstname: firstNameField.value,
                                                lastname: lastNameField.value,
                                                company: getCompanyForHbEntry()
                                            };

                                            Cookies.set('hbEntry', JSON.stringify(hbEntry), {
                                                domain: "exactdata.com",
                                                path: "/",
                                                expires: 30,
                                                secure: (window.location.protocol === 'https:')
                                            });

                                            // Use base URL without query parameters (data is in hbEntry cookie)
                                            const thankYouUrl = baseUrl;

                                            setTimeout(() => {
                                                window.location.href = thankYouUrl;
                                            }, 100);
                                            return; // Stop further execution
                                        }
                                    }
                                } catch (contactCheckError) {
                                    console.error('=== Salesforce Contact Check API Error ===');
                                    console.error('→ Form:', formTitle);
                                    console.error('→ Email:', emailField.value);
                                    console.error('→ Error:', contactCheckError.message);
                                    console.error('→ Error Response:', contactCheckError.response?.data);
                                    console.error('→ Error Status:', contactCheckError.response?.status);
                                }

                                // If we reach here, contact check failed - continue with old flow
                                // Don't redirect, let the old flow handle it (form submission to /hubspot-form)
                            }
                        } catch (error) {
                            console.error('→ GetProductListOfUser API failed:', error.message);

                            // Step 3: Call Salesforce APIs - First get token, then check if contact exists
                            // This handles the case when GetProductListOfUser API fails
                            let contactExists = false;

                                try {

                                    const contactCheckResponse = await window.axios.post('/check-salesforce-contact', {
                                        email: emailField.value
                                    });

                                    if (contactCheckResponse.data?.success) {
                                        contactExists = contactCheckResponse.data.isContactExist || false;
                                        const sfContactId = contactCheckResponse.data.SFContactId || null;

                                        // Step 4: Call Salesforce API to update (if exists) or create (if new) with salesgenie_product_experiment
                                        try {

                                            // Refresh heap_session_id at submission time to get the latest value from Heap
                                            const latestHeapSessionId = processHeapData();
                                            if (heap_session_id) {
                                                heap_session_id.value = latestHeapSessionId;
                                            }

                                            // Prepare Salesforce payload with all form data + salesgenie_product_experiment
                                            const sfPayload = {
                                                firstname: firstNameField.value,
                                                lastname: lastNameField.value,
                                                companyname: company.value,
                                                phone: phoneField.value,
                                                email: emailField.value,
                                                ip: ip.value,
                                                hsformtitle: hubspot_form_title.value,
                                                page_url_long_text: page_url.value,
                                                leadsource: leadsource.value,
                                                mediacode: media_code.value,
                                                campaignid: sfcid.value,
                                                comments: placeholdertext.value,
                                                device: devicevalue.value,
                                                gclid: gclid.value,
                                                msclkid: ms_click_id.value,
                                                utm_campaign: utm_campaign.value,
                                                utm_medium: utm_medium.value,
                                                utm_content: utm_content.value,
                                                utm_source: utm_source.value,
                                                utm_term: utm_term.value,
                                                google_campaign: google_analytics_campaign.value,
                                                adgroupid: adgroup_id.value,
                                                keyword: keyword.value,
                                                matchtype: matchtype.value,
                                                network: network.value,
                                                extensionid: extension_id.value,
                                                fbclid: fbclid.value,
                                                facebook_cookie_fbp: facebook_cookie_fbp.value,
                                                facebook_cookie_fbc: facebook_cookie_fbc.value,
                                                browser_user_agent: browser_user_agent.value,
                                                bp_phone_status: bp_phone_status.value,
                                                bp_line_type: bp_line_type.value,
                                                heap_session_id: (heap_session_id && heap_session_id.value) ? heap_session_id.value : '', // Include heap session ID from hidden form field
                                                mediacode: (media_code && media_code.value) ? media_code.value : 'EXDCMSW00100',
                                                single_tracking_parameter: true, // Ensure only 1 tracking parameter record is created
                                                salesgenie_product_experiment: 'Unify – ED > NXG',
                                                // Pass contact existence info from check API
                                                contact_exists: contactExists,
                                                sf_contact_id: sfContactId
                                            };
                                            
                                            const sfResponse = await window.axios.post('/send-to-salesforce', sfPayload);

                                            // Both scenarios: Redirect to thank you salesgenie page
                                            const baseUrl = sfResponse.data?.redirect_url 
                                                || (typeof window.SALESGENIE_THANK_YOU_URL !== 'undefined' && window.SALESGENIE_THANK_YOU_URL)
                                                || 'https://exactdata.com/info/thank-you-salesgenie/';

                                            // Set hbEntry cookie (same pattern as reference code)
                                            // Extract 10-digit phone number (remove formatting)
                                            const phoneValue = phoneField && phoneField.value ? phoneField.value.replace(/\D/g, '').substring(0, 10) : '';
                                            const hbEntry = {
                                                email: emailField.value,
                                                phone: phoneValue,
                                                firstname: firstNameField.value,
                                                lastname: lastNameField.value,
                                                company: getCompanyForHbEntry()
                                            };

                                            // Set cookie with 30 days expiry, domain exactdata.com, secure only on https
                                            Cookies.set('hbEntry', JSON.stringify(hbEntry), {
                                                domain: "exactdata.com",
                                                path: "/",
                                                expires: 30,
                                                secure: (window.location.protocol === 'https:')
                                            });

                                            // Store tracking parameters in cookies (not in URL)
                                            const trackingParams = [
                                                'keyword', 'matchtype', 'network', 'adposition', 'adgroupid',
                                                'gclid', 'msclkid', 'utm_source', 'utm_medium', 'utm_campaign',
                                                'utm_term', 'utm_content', 'campaignid', 'extensionid', 'sfcid',
                                                'media_code', 'facebook_cookie_fbc', 'facebook_cookie_fbp', 'fbclid', 'leadsource'
                                            ];

                                            // Store tracking params in cookie
                                            const trackingParamsObj = {};
                                            trackingParams.forEach(param => {
                                                const value = getCookie(param) ||
                                                             (param === 'sfcid' ? sfcid.value :
                                                              param === 'gclid' ? gclid.value :
                                                              param === 'msclkid' ? ms_click_id.value :
                                                              param === 'utm_campaign' ? utm_campaign.value :
                                                              param === 'utm_term' ? utm_term.value :
                                                              param === 'utm_source' ? utm_source.value :
                                                              param === 'utm_medium' ? utm_medium.value :
                                                              param === 'utm_content' ? utm_content.value :
                                                              param === 'adgroupid' ? adgroup_id.value :
                                                              param === 'extensionid' ? extension_id.value :
                                                              param === 'facebook_cookie_fbc' ? facebook_cookie_fbc.value :
                                                              param === 'facebook_cookie_fbp' ? facebook_cookie_fbp.value :
                                                              param === 'fbclid' ? fbclid.value :
                                                              param === 'leadsource' ? leadsource.value :
                                                              param === 'media_code' ? media_code.value :
                                                              param === 'campaignid' ? google_analytics_campaign.value : null);

                                                if (value && value !== 'Not Present' && value !== '') {
                                                    trackingParamsObj[param] = value;
                                                    setCookie(param, value, 30);
                                                }
                                            });

                                            if (Object.keys(trackingParamsObj).length > 0) {
                                                const date = new Date();
                                                date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
                                                const expires = "expires=" + date.toUTCString();
                                                let cookieString = "_tracking_params" + "=" + encodeURIComponent(JSON.stringify(trackingParamsObj)) + "; " + expires + "; path=/; SameSite=Lax";
                                                document.cookie = cookieString;
                                            }

                                            // Use base URL without query parameters (data is in cookies)
                                            const thankYouUrl = baseUrl;

                                            // Small delay to ensure cookie is persisted
                                            setTimeout(() => {
                                                window.location.href = thankYouUrl;
                                            }, 100);
                                            return; // Stop further execution

                                        } catch (sfError) {
                                            console.error('=== Salesforce Send API Error (Error Fallback) ===');
                                            console.error('→ Form:', formTitle);
                                            console.error('→ Email:', emailField.value);
                                            console.error('→ Error:', sfError.message);
                                            console.error('→ Error Response:', sfError.response?.data);
                                            console.error('→ Error Status:', sfError.response?.status);
                                            console.error('→ Full Error:', sfError);
                                            // Still redirect even if Salesforce call fails
                                            const baseUrl = (typeof window.SALESGENIE_THANK_YOU_URL !== 'undefined' && window.SALESGENIE_THANK_YOU_URL) 
                                                ? window.SALESGENIE_THANK_YOU_URL 
                                                : 'https://exactdata.com/info/thank-you-salesgenie/';

                                            // Set hbEntry cookie (error fallback)
                                            const phoneValue = phoneField && phoneField.value ? phoneField.value.replace(/\D/g, '').substring(0, 10) : '';
                                            const hbEntry = {
                                                email: emailField.value,
                                                phone: phoneValue,
                                                firstname: firstNameField.value,
                                                lastname: lastNameField.value,
                                                company: getCompanyForHbEntry()
                                            };

                                            Cookies.set('hbEntry', JSON.stringify(hbEntry), {
                                                domain: "exactdata.com",
                                                path: "/",
                                                expires: 30,
                                                secure: (window.location.protocol === 'https:')
                                            });

                                            // Use base URL without query parameters (data is in hbEntry cookie)
                                            const thankYouUrl = baseUrl;

                                            setTimeout(() => {
                                                window.location.href = thankYouUrl;
                                            }, 100);
                                            return; // Stop further execution
                                        }
                                }
                            } catch (contactCheckError) {
                                console.error('=== Salesforce Contact Check API Error (Error Fallback) ===');
                                console.error('→ Form:', formTitle);
                                console.error('→ Email:', emailField.value);
                                console.error('→ Error:', contactCheckError.message);
                                console.error('→ Error Response:', contactCheckError.response?.data);
                                console.error('→ Error Status:', contactCheckError.response?.status);
                            }

                            // If we reach here, contact check failed - continue with old flow
                            // Don't redirect, let the old flow handle it (form submission to /hubspot-form)
                        }
                    } else {
                        // For ED, ExactData, or any other UserFlowType, proceed with old flow
                    }
                } catch (error) {
                    // Log error but don't block form submission
                    console.error('→ GetRegistrationFlow API failed:', error.message);
                    // Fallback to old flow if GetRegistrationFlow fails
                }

                // Refresh heap_session_id at submission time to get the latest value from Heap
                const latestHeapSessionId = processHeapData();
                if (heap_session_id) {
                    heap_session_id.value = latestHeapSessionId;
                }

                let hubspotData= {
                    firstname:firstNameField.value,
                    lastname:lastNameField.value,
                    // If company is null/empty, fall back to "firstname lastname"
                    companyname:(company && company.value && company.value.trim() !== ''
                        ? company.value
                        : (String(firstNameField?.value || '').trim() + ' ' + String(lastNameField?.value || '').trim()).trim()),
                    phone:phoneField.value,
                    email:emailField.value,
                    ip:ip.value,
                    hsformtitle:hubspot_form_title.value,
                    page_url_long_text:page_url.value,
                    leadsource:leadsource.value,
                    mediacode:media_code.value,
                    campaignid:sfcid.value,
                    comments:placeholdertext.value,
                    device:devicevalue.value,
                    gclid:gclid.value,
                    msclkid:ms_click_id.value,
                    utm_campaign:utm_campaign.value,
                    utm_medium:utm_medium.value,
                    utm_content:utm_content.value,
                    utm_source:utm_source.value,
                    utm_term:utm_term.value,
                    google_campaign:google_analytics_campaign.value,
                    adgroupid:adgroup_id.value,
                    keyword:keyword.value,
                    matchtype:matchtype.value,
                    network:network.value,
                    extensionid:extension_id.value,
                    fbclid:fbclid.value,
                    facebook_cookie_fbp:facebook_cookie_fbp.value,
                    facebook_cookie_fbc:facebook_cookie_fbc.value,
                    browser_user_agent:browser_user_agent.value,
                    bp_phone_status:bp_phone_status.value,
                    bp_line_type:bp_line_type.value,
                    heap_session_id: (heap_session_id && heap_session_id.value) ? heap_session_id.value : '', // Include heap session ID from hidden form field (refreshed at submission)
                    mediacode:(media_code && media_code.value) ? media_code.value : 'EXDCMSW00100',
                    single_tracking_parameter: true, // Ensure only 1 tracking parameter record is created
                    salesgenie_product_experiment: 'Unify – ED > NXG', // Include salesgenie product experiment value
                };

                // Only include salesgenie_product_list if UserFlowType is NXG (not for ED/ExactData)
                if (salesgenieProductList) {
                    hubspotData.salesgenie_product_list = JSON.stringify(salesgenieProductList);
                }

                await window.axios.post('/hubspot-form', hubspotData).then(function (response) {
                    if(response.data.response) {
                        return true;
                    }
                    return false;
                }).catch((error) => {
                    console.error('→ Hubspot form error:', error.message);
                    return false;
                });

                if (typeForm && typeForm === "promo") {
                    window.axios.post("/cookie/set", {
                        name: "promo-modal-lead",
                        value: "true",
                        minutes: 60 * 24 * 365,
                        domain: COOKIE_DOMAIN
                    }).then(() => {
                        $form[0].submit();
                        return true;
                    });
                } else {
                    $form.submit();
                }
            } else {
                $('.loader').css('display','none');
                submitBtn.removeAttribute("disabled");
                // submitBtn.value = "SUBMIT";
                //$form[0].querySelector(".hs-button ").trigger('click', ['run']);
                return true;
                // submitBtn.innerHTML = btnText;
            }
        }
    });
}

window.addEventListener('message', event => {
    if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
        setTimeout(function() {
            $('.loader').css('display','none');
        }, 2500);
    }
});

export function processHeapData() {
    const heap = typeof window !== 'undefined' ? window.heap : null;

    if (!heap || typeof heap !== 'object') {
        return 'Heap Undefined';
    }

    if (heap.loaded && typeof heap.getSessionId === 'function') {
        return heap.getSessionId();
    }

    return 'Not Available';
}

